export const windowService = {
    isInIFrame: () => window.self !== window.top,
};
